import { FC } from 'react'
import { Badge } from 'components/Badge'
import { BotIcon } from 'lucide-react'
import { cn } from '@wellesley/ui'

type BotBadgeProps = {
  className?: string
}

const BotBadge: FC<BotBadgeProps> = ({ className }) => {
  return (
    <Badge
      variant="success"
      className={cn('flex size-4 items-center justify-center p-0', className)}
      icon={<BotIcon size={12} className="shrink-0" />}
    />
  )
}

export default BotBadge
